import { Component, OnInit } from '@angular/core';
import { AzureAuthService } from 'src/service/azure-auth.service';
import { Router } from '@angular/router';
import { AuthenticationResult } from '@azure/msal-browser';
import { ApplicationConfigService } from 'src/service/application-config.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {

  constructor(public azureAuthService: AzureAuthService, private router: Router, public app: ApplicationConfigService) { }

  ngOnInit(): void {
    console.log("Login");
    this.azureAuthService.isAuthenticated();
  }

  logout(){
    this.azureAuthService.logout();
  }

  loginAzure() {
    this.azureAuthService.login().subscribe({
      next: (result: AuthenticationResult) => {
        // Authentication successful
        console.log('Login successful:', result);
        // Navigate to /home
        this.router.navigate(['/home']);
      },
      error: (error) => {
        // Handle authentication errors
        console.error('Login failed:', error);
        // Optional: Display an error message to the user
      }
    });
  }

}
